export default __webpack_public_path__ + "static/media/whol.93584097.png";